export default __webpack_public_path__ + "static/media/SD-ganapathi-homam-img.cf1bea91.png";